import { render } from "./ProjectEarlierResearch.vue?vue&type=template&id=08a09724&scoped=true"
import script from "./ProjectEarlierResearch.vue?vue&type=script&lang=js"
export * from "./ProjectEarlierResearch.vue?vue&type=script&lang=js"

import "./ProjectEarlierResearch.vue?vue&type=style&index=0&id=08a09724&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a09724"]])

export default __exports__